import { useState } from 'react';

export default function useGroupHistory(
	getGroupHistoryQuery: any,
	customSkip?: number,
) {
	const [page, setPage] = useState(1);
	const getGroupHistory = (filter: any) => {
		const skip = customSkip ?? 20;
		getGroupHistoryQuery({
			...filter,
			pagination: {
				...filter.pagination,
				skip: (page - 1) * skip,
			},
		});
	};

	const getNextPage = () => {
		setPage(prev => prev + 1);
	};

	return { getGroupHistory, getNextPage, page, setPage };
}
